import { jsx as _jsx } from "react/jsx-runtime";
import { bemClassBuilder } from '@vista-digital/bem-class-builder';
import { observer } from 'mobx-react';
import { useCallback } from 'react';
import { Button } from '../../../../subcomponents/button/button';
import { ButtonColor } from '../../../../subcomponents/button/types/color';
import { ButtonSize } from '../../../../subcomponents/button/types/size';
import { Message } from '../../../../subcomponents/message/message';
export var OrderSeatPickerMessageType;
(function (OrderSeatPickerMessageType) {
    OrderSeatPickerMessageType["FailedToLoadData"] = "FailedToLoadData";
    OrderSeatPickerMessageType["SoldOut"] = "SoldOut";
})(OrderSeatPickerMessageType || (OrderSeatPickerMessageType = {}));
const b = bemClassBuilder('v-order-seat-picker-message');
export const OrderSeatPickerMessage = observer(props => {
    const { messageType, displayText, assets, config, events } = props;
    const showActionButton = config.messageActionButton.show && messageType !== OrderSeatPickerMessageType.FailedToLoadData;
    const handleMessageActionButtonClicked = useCallback(() => {
        var _a;
        (_a = events.onMessageActionButtonClicked) === null || _a === void 0 ? void 0 : _a.call(events);
    }, [events]);
    return (_jsx(Message, Object.assign({}, getOrderSeatPickerMessageProps(messageType, assets, displayText), { className: b.block() }, { children: showActionButton && (_jsx(Button, { className: b.element('action-button'), label: displayText.messageActionButtonLabel, color: ButtonColor.Primary, size: ButtonSize.Large, onClick: handleMessageActionButtonClicked })) })));
});
OrderSeatPickerMessage.displayName = 'OrderSeatPickerMessage';
const getOrderSeatPickerMessageProps = (messageType, assets, displayText) => {
    switch (messageType) {
        case OrderSeatPickerMessageType.SoldOut:
            return {
                iconName: assets.soldOutIconName,
                title: displayText.soldOutTitle,
                description: displayText.soldOutMessage
            };
        case OrderSeatPickerMessageType.FailedToLoadData:
        default:
            return {
                iconName: assets.failedToLoadDataIconName,
                title: displayText.failedToLoadDataTitle,
                description: displayText.failedToLoadDataMessage
            };
    }
};
